/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_SettingsInputs */

const th_event_settings = /** @type {(inputs: Event_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายละเอียดการแข่งขัน`)
};

const en_event_settings = /** @type {(inputs: Event_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event details`)
};

const ja_event_settings = /** @type {(inputs: Event_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントの詳細`)
};

const zh_event_settings = /** @type {(inputs: Event_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`赛事信息`)
};

const es_event_settings = /** @type {(inputs: Event_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles del evento`)
};

const pt_event_settings = /** @type {(inputs: Event_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhes do evento`)
};

const id_event_settings = /** @type {(inputs: Event_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detail acara`)
};

const fr_event_settings = /** @type {(inputs: Event_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détails de l’événement`)
};

const tl_event_settings = /** @type {(inputs: Event_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalye ng event`)
};

const vi_event_settings = /** @type {(inputs: Event_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chi tiết sự kiện`)
};

const ko_event_settings = /** @type {(inputs: Event_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이벤트 정보`)
};

const de_event_settings = /** @type {(inputs: Event_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event-Details`)
};

const ru_event_settings = /** @type {(inputs: Event_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Данные события`)
};

const tr_event_settings = /** @type {(inputs: Event_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlik bilgileri`)
};

const it_event_settings = /** @type {(inputs: Event_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dettagli dell'evento`)
};

const pl_event_settings = /** @type {(inputs: Event_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szczegóły wydarzenia`)
};

const uk_event_settings = /** @type {(inputs: Event_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дані події`)
};

const hi_event_settings = /** @type {(inputs: Event_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयोजन का विवरण`)
};

const ar_event_settings = /** @type {(inputs: Event_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تفاصيل الفعالية`)
};

const ms_event_settings = /** @type {(inputs: Event_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Butiran acara`)
};

const bn_event_settings = /** @type {(inputs: Event_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আয়োজনের বিবরণ`)
};

const zh_tw2_event_settings = /** @type {(inputs: Event_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`賽事資訊`)
};

const zh_hk2_event_settings = /** @type {(inputs: Event_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`賽事資訊`)
};

const ur_event_settings = /** @type {(inputs: Event_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ایونٹ کی تفصیل`)
};

const fa_event_settings = /** @type {(inputs: Event_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جزئیات رویداد`)
};

const sw_event_settings = /** @type {(inputs: Event_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maelezo ya tukio`)
};

const nl_event_settings = /** @type {(inputs: Event_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gegevens van het evenement`)
};

/**
* | output |
* | --- |
* | "Event details" |
*
* @param {Event_SettingsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_settings = /** @type {((inputs?: Event_SettingsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_SettingsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_settings(inputs)
	if (locale === "ja") return ja_event_settings(inputs)
	if (locale === "zh") return zh_event_settings(inputs)
	if (locale === "es") return es_event_settings(inputs)
	if (locale === "pt") return pt_event_settings(inputs)
	if (locale === "id") return id_event_settings(inputs)
	if (locale === "fr") return fr_event_settings(inputs)
	if (locale === "tl") return tl_event_settings(inputs)
	if (locale === "vi") return vi_event_settings(inputs)
	if (locale === "ko") return ko_event_settings(inputs)
	if (locale === "de") return de_event_settings(inputs)
	if (locale === "ru") return ru_event_settings(inputs)
	if (locale === "tr") return tr_event_settings(inputs)
	if (locale === "it") return it_event_settings(inputs)
	if (locale === "pl") return pl_event_settings(inputs)
	if (locale === "uk") return uk_event_settings(inputs)
	if (locale === "hi") return hi_event_settings(inputs)
	if (locale === "ar") return ar_event_settings(inputs)
	if (locale === "ms") return ms_event_settings(inputs)
	if (locale === "bn") return bn_event_settings(inputs)
	if (locale === "zh-TW") return zh_tw2_event_settings(inputs)
	if (locale === "zh-HK") return zh_hk2_event_settings(inputs)
	if (locale === "ur") return ur_event_settings(inputs)
	if (locale === "fa") return fa_event_settings(inputs)
	if (locale === "sw") return sw_event_settings(inputs)
	if (locale === "nl") return nl_event_settings(inputs)
	return en_event_settings(inputs)
});